
import { useState } from 'react';
import Hero from './components/Hero';
import BrandIntro from './components/BrandIntro';
import ProductComparison from './components/ProductComparison';
import BuyingGuide from './components/BuyingGuide';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ScrollToTop from '../../components/feature/ScrollToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <BrandIntro />
      <ProductComparison />
      <BuyingGuide />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
      <ScrollToTop />
    </div>
  );
}
